import styled from '@emotion/styled';
import { UDButton } from 'ud-ui/components';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 30px;
  gap: 20px;

  background: ${({ theme }) => theme.colors.SurfaceWhite};
  border-radius: 8px;
  border: 0.5px solid #1a1a291a;

  min-width: 325px;
  min-height: 244px;

  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out;

  &:hover {
    box-shadow: 0px 8px 16px rgba(26, 26, 41, 0.08);
  }
`;

export const ExpandButtonWrapper = styled(UDButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0;

  width: 40px;
  height: 40px;

  border-radius: 50%;

  background: ${({ theme }) => theme.colors.DarkYellow};
  color: ${({ theme }) => theme.colors.DarkBlue};

  &:hover {
    background: ${({ theme }) => theme.colors.DarkYellow};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background: #9093aa1a;
  color: ${({ theme }) => theme.colors.DarkYellow};

  width: 28px;
  height: 28px;
  border-radius: 4px;
`;
